import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
export { FontAwesomeIcon };

const firebaseConfig = {
  apiKey: "AIzaSyCscJy8FCOO3pVajPhlHEcnN17uW9BExXc",
  authDomain: "vb-parkfinder-f5eee.firebaseapp.com",
  databaseURL: "https://vb-parkfinder-f5eee.firebaseio.com",
  projectId: "vb-parkfinder-f5eee",
  storageBucket: "vb-parkfinder-f5eee.firebasestorage.app",
  messagingSenderId: "791804375499",
  appId: "1:791804375499:web:5876574f8402988939464e",
  measurementId: "G-DY4ZFQVDR5",
};

const app = initializeApp(firebaseConfig);

export const initialUrl = async () => window.location.href;
export const tabIconSize = "xl";
export const platform = "web";
export const logAnalyticsEvent = (name, params) => {
  if (process.env.REACT_APP_ENV === "prod") {
    const analytics = getAnalytics(app);
    if (analytics) {
      logEvent(analytics, name, params);
    }
  }
};
export const isMobileOrMobileWeb = () => {
  if (typeof window === "undefined") {
    return false;
  } else {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iphone|ipad|ipod/i.test(userAgent);
  }
};
